import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { toWords } from "number-to-words";
import logo from "../../Admin/images/PPKM_Logo.png"; // Ensure the path is correct

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
  ],
});

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    // backgroundColor: "#E4E4E4",
    fontFamily: "Open Sans",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between", // Space between items in the row
    alignItems: "center", // Center items vertically
    marginBottom: 10, // Space between rows
  },
  rowEnd: {
    flexDirection: "row",
    justifyContent: "flex-end", // Aligns text to the end of the row
    alignItems: "center", // Center items vertically
  },
  rowMain: {
    flexDirection: "row",
    justifyContent: "space-between", // Space between items in the row
  },
  section: {
    flexGrow: 1,
  },
  sectionHeaderTitle: {
    marginLeft: 50,
    fontSize: 9,
  },
  sectionHeaderBox: {
    marginLeft: 42,
    fontSize: 8,
  },
  box: {
    borderWidth: 1, // Set the border width this
    borderColor: "black",
    padding: 10, // Add padding inside the box for better spacing
    marginTop: 10, // Space above the box
    width: "100%", // Ensure the box takes full width of the page
    fontSize: 9,
  },
  box1: {
    borderBottomWidth: 1, // Set the border width this
    borderBottomColor: "black",
    marginTop: 4, // Space above the box
    width: "100%", // Ensure the box takes full width of the page
    fontSize: 9,
  },
  boxContent: {
    fontSize: 9,
    marginTop: 5,
  },
  boxNote: {
    fontSize: 9,
    marginTop: 35,
    width: "50%",
    marginLeft: 30,
  },
  endBox: {
    marginTop: "auto", // Pushes the box to the bottom of the page
    borderTop: "1px solid black",
    fontSize: 9,
  },
  Box3: {
    marginTop: "auto", // Pushes the box to the bottom of the page
    borderTop: "1px solid black",
    fontSize: 9,
  },
  column: {
    width: "50%",
  },
  cell: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderTop: "1px solid #000",
    borderLeft: "1px solid #000",
    borderRight: "1px solid #000",
    paddingVertical: 5,
  },
  cell1: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #000",
    borderLeft: "1px solid #000",
    borderRight: "1px solid #000",
    borderTop: "1px solid #000",
    paddingVertical: 5,
  },
  boldText: {
    fontWeight: "bold",
  },
  divider: {
    width: 1,
    height: "auto",
    backgroundColor: "#000",
    marginHorizontal: 5, // Adjusts space around the divider
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  rowTable: {
    flexDirection: "row", // Aligns cells horizontally within each row
  },
  headerCell: {
    flex: 1,
    padding: 1,
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontWeight: "bold",
  },
  cellTable: {
    flex: 1,
    padding: 1,
    borderRightWidth: 1,
    borderColor: "#000",
  },
  lastCell: {
    flex: 1,
    padding: 1,
  },
  cellTable1: {
    flex: 1,
    padding: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderColor: "#000",
  },
  lastCell1: {
    flex: 1,
    padding: 1,
    borderTopWidth: 1,
    borderColor: "#000",
  },
  boxNoteFooter: {
    fontSize: 9,
    borderWidth: 1, // Set the border width this
    borderColor: "black",
    padding: 1,
    fontWeight: "ultrabold", // Optional: Make the header bold
  },
  textAlignRight: {
    textAlign: "right",
  },
});

// Create Document Component
const MyDocument = ({
  paymentID,
  company_name,
  email,
  date_time,
  date,
  address,
  contact_name,
  memberID,
  payment_item,
  invoice_no,
  fee_amounts,
  invoice_notes,
}) => {
  let address_array;
  if (address) {
    address_array = address.split(", ");
  }

  let total = 0;
  let fullAmountInWords = "";

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* First Row: Logo on the right */}
        <View style={styles.row}>
          <View style={styles.section}>
            {/* Empty view to balance the logo position */}
          </View>
          <Image
            src={logo} // Use the imported logo
            style={{ width: "250px", height: "auto" }} // Adjust size as needed
          />
        </View>

        {/* Subsequent Rows: Address and details */}
        <View style={styles.sectionHeaderTitle}>
          <Text style={{ fontWeight: "ultrabold" }}>
            PERSATUAN PENGURUSAN KOMPLEKS MALAYSIA (PPK)
          </Text>
          <Text>A608, 6th Floor, Block A, No. 1, Jalan SS20/27,</Text>
          <Text>Damansara Intan, 47400 Petaling Jaya, Selangor</Text>
          <Text>Tel: 03-7727 6202 {"  "} Email: secretariat@ppkm.org.my</Text>
          <Text style={{ fontWeight: "ultrabold" }}>
            (SST No: B16-1903-32000068)
          </Text>
        </View>

        <View style={styles.box}>
          <View style={styles.sectionHeaderBox}>
            <Text style={{ fontWeight: "ultrabold", marginBottom: "10px" }}>
              {company_name}
            </Text>

            {address_array &&
              address_array.map((element, index) => (
                <Text key={index}>{element}</Text>
              ))}
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {/* Left Column */}
              <View
                style={{ flex: 1, alignItems: "flex-start", marginRight: 30 }}
              >
                <Text>Attn: {contact_name}</Text>
                <Text>Membership No: {memberID}</Text>
              </View>

              {/* Right Column */}
              <View style={{ flex: 1, alignItems: "flex-end" }}>
                <Text style={{ fontWeight: "bold" }}>
                  Invoice: {invoice_no}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>Date: </Text>
                  {date}
                </Text>
                <Text style={{ fontWeight: "bold" }}>Page:</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.box1}>
          <View style={styles.rowMain}>
            {/* Inline element for "No" */}
            <View style={{ width: "5%" }}>
              <Text style={{ fontWeight: "ultrabold" }}>No</Text>
            </View>
            {/* Inline element for "Description" */}
            <View style={{ width: "55%" }}>
              <Text style={{ fontWeight: "ultrabold" }}>Description</Text>
            </View>
            <View style={{ width: "5%" }}>
              <Text style={{ fontWeight: "ultrabold" }}>Qty</Text>
            </View>
            <View style={{ width: "15%" }}>
              <Text style={{ fontWeight: "ultrabold" }}>Unit Price</Text>
            </View>
            <View style={{ width: "15%" }}>
              <Text style={{ fontWeight: "ultrabold" }}>Amount</Text>
            </View>
            <View style={{ width: "5%" }}>
              <Text style={{ fontWeight: "ultrabold" }}>SST</Text>
            </View>
          </View>
        </View>
        <View style={styles.boxContent}>
          {payment_item &&
            payment_item.map((item: any, index: number) => {
              const datetime_created = item.datetime_created;
              const year = datetime_created.split("-")[0];

              const amountsArray =
                fee_amounts &&
                typeof fee_amounts === "string" &&
                fee_amounts.trim() !== "" // Check if fee_amounts is a non-empty string
                  ? fee_amounts.includes(",")
                    ? fee_amounts.split(",").map(Number) // Split and convert to numbers
                    : [Number(fee_amounts)] // Convert directly to a single-number array
                  : []; // Return an empty array if fee_amounts is falsy or empty

              total += amountsArray[index] || 0; // Add the indexed amount to total, fallback to 0 if undefined

              const amountWords = toWords(Math.floor(total)).toUpperCase(); // Convert the integer part to words
              const fractionalPart = Math.round((total % 1) * 100); // Extract cents
              fullAmountInWords =
                fractionalPart > 0
                  ? `${amountWords} AND ${fractionalPart} CENTS`
                  : `${amountWords}`;

              return (
                <>
                  <View style={styles.rowMain}>
                    <View style={{ width: "5%" }}>
                      <Text>{index + 1}</Text>
                    </View>
                    <View style={{ width: "55%" }}>
                      <Text style={{ fontWeight: "ultrabold" }}>
                        {item.type === 0
                          ? "Being New " + item.label + " For Year " + year
                          : item.label}
                      </Text>
                      <Text>
                        {item.type === 1
                          ? "ANNUAL SUBSCRIPTION FEE"
                          : "ENTRANCE FEE"}
                      </Text>
                    </View>
                    <View style={{ width: "5%" }}>
                      <Text>1</Text>
                    </View>
                    <View style={{ width: "15%" }}>
                      <Text>
                        {Number(amountsArray[index]).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>
                    <View style={{ width: "15%" }}>
                      <Text>
                        {Number(amountsArray[index]).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>
                    <View style={{ width: "5%" }}>
                      <Text></Text>
                    </View>
                  </View>
                </>
              );
            })}
        </View>

        <View style={styles.boxNote}>
          {/* <Text style={{ fontWeight: "ultrabold" }}>
            NOTE: Extract from PPK's Rules & Constitution
          </Text>
          <Text>
            Rule 6 (1): In the case of new members who are admitted on 1st
            January to 30th June of the calendar year (30th June being the Cut
            Off Date), their first subscriptions shall be taken as full year's
            subscription; whereas, for new members who are admitted after the
            Cut off Date, their subscriptions be shall proportionate to the 2nd
            half of the year's subscription and the balance shall be carried
            forward for the first half of the subsequent year.
          </Text> */}
          {invoice_notes.map((item_note, index_note) =>
            item_note.map((item) => (
              <>
                <Text style={{ fontWeight: "bold" }}> {item.title}</Text>
                <Text> {item.description}</Text>
              </>
            ))
          )}
        </View>

        {/* Final Box at the end of the page */}
        <View style={styles.endBox}>
          <Text>RINGGIT MALAYSIA: {fullAmountInWords} ONLY</Text>

          {/* first row */}
          <View style={styles.rowEnd}>
            {/* Column 1 - Empty for spacing */}
            <View style={styles.column}></View>

            {/* Column 2 - Table with two rows */}
            <View style={styles.column}>
              <View style={styles.table}>
                {/* Header Row */}
                <View style={styles.rowTable}>
                  <Text style={styles.headerCell}>Total Excl.SST (RM)</Text>
                  <Text style={[styles.lastCell, styles.textAlignRight]}>
                    {total.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>

                {/* Subsequent Rows */}
                <View style={styles.rowTable}>
                  <Text style={styles.cellTable}>SST 8%</Text>
                  <Text style={[styles.lastCell, styles.textAlignRight]}>
                    0.00
                  </Text>
                </View>
                <View style={styles.rowTable}>
                  <Text style={styles.cellTable1}>
                    Total Payable Incl.SST (RM)
                  </Text>
                  <Text style={[styles.lastCell1, styles.textAlignRight]}>
                    {total.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* second row */}
          <View style={styles.rowEnd}>
            {/* column 1 */}
            <View style={styles.column}>
              <Text style={{ fontWeight: "ultrabold" }}>
                Persatuan Pengurusan Kompleks Malaysia (PPK)
              </Text>
              <Text style={{ marginTop: "50px" }}></Text>
              <Text>____________________________________</Text>
              <Text style={{ marginLeft: "10px", fontWeight: "ultrabold" }}>
                Authorised Signature
              </Text>
            </View>

            {/* column 2 */}
            <View style={styles.column}>
              <View style={styles.boxNoteFooter}>
                <Text>
                  Payable to Persatuan Pengurusan Kompleks Malaysia (PPK)
                </Text>
                <Text>CIMB Bank A/C: 8002-636-850</Text>
                <Text>A/C Reg. No : 355984 (For Online Payment)</Text>
                <Text>
                  Please email bank in slip to : secretariat@ppkm.org.my
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument;
